import CountrySwitcherMobile from './CountrySwitcherMobile'

export default CountrySwitcherMobile
